import React, { useEffect } from "react";

import { Button, TextInput } from "@toddle-edu/ds-web";

import classes from "./VerifyParentInviteCode.scss";

// This screen will never be used for family class invite and for invited family member via email
const VerifyParentInviteCode = props => {
  const {
    renderBackButtonComponent,
    updateInputField,
    data: { inviteCode } = {},
    customStyle: { headerStyleV2, subTextStyle } = {},
    updateCurrentScreen,
    parentInviteCode,
    setParentInviteCode,
    renderTradeMarkText,
    isOrgWorkspaceLoginPage = false,
    isCreateParentAccountEnabled,
  } = props;

  // onClick functions
  const onBackClick = () => {
    if (parentInviteCode) {
      setParentInviteCode(null);
    }

    updateCurrentScreen({ type: "parentLogin" });
    updateInputField({});
  };

  const onSubmitClick = () => {
    const { handleVerifyParentInviteCode } = props;

    if (!inviteCode) return;
    handleVerifyParentInviteCode();
  };

  const handleKeyPress = e => {
    if (e.key === "Enter") {
      onSubmitClick();
    }
  };

  const containerStyle = {
    paddingTop: isOrgWorkspaceLoginPage ? "13%" : "19.5%",
  };

  useEffect(() => {
    if (!isCreateParentAccountEnabled) {
      onBackClick();
    }
  }, [isCreateParentAccountEnabled]);

  return (
    <div
      className={classes.container}
      style={containerStyle}
      role="main"
      aria-label="Family invite code verification"
    >
      <div>
        <div className={classes.headerButtonContainer}>
          {renderBackButtonComponent({
            onClick: onBackClick,
            buttonText: "Family account",
            currentStep: 1,
            maxStep: 2,
            ariaLabel: "Go back to family login options",
          })}
        </div>
        <div className={classes.headerContainer}>
          <div style={headerStyleV2}> {"Create your Toddle account"} </div>
          <div style={subTextStyle}>
            {
              "Please ask your child’s teacher for the invite code, if you don’t have one."
            }
          </div>
        </div>
        <div className={classes.inviteCodeContainer}>
          <div className={classes.inputContainer}>
            <TextInput
              dsVersion="2.0"
              size={"large"}
              textInputLabel={"Family invite code*"}
              placeholder={"Enter your family invite code"}
              value={inviteCode}
              name={"inviteCode"}
              autoFocus={true}
              onChange={e => {
                updateInputField({
                  inviteCode: e.target.value,
                });
              }}
              onKeyPress={handleKeyPress}
            />
          </div>

          <div className={classes.buttonContainer}>
            <Button
              dsVersion="2.0"
              size={"large"}
              type="fill"
              variant={"primary"}
              isFullWidth={true}
              onClick={onSubmitClick}
              disabled={!inviteCode}
              aria-label="Continue with family invite code"
            >
              {"Continue"}
            </Button>
          </div>
        </div>
      </div>
      <div>
        {renderTradeMarkText({
          align: "left",
        })}
      </div>
    </div>
  );
};

export default VerifyParentInviteCode;
